export class AccountPassword {
    public currentPassword: string;
    public newPassword: string;
    public isSuccess: boolean;
}
